import React, { memo } from "react";
import PropTypes from "prop-types";
import ButtonElement from "../elements/button";

const Button = memo(({ children, ...otherProps }) => {
  return <ButtonElement {...otherProps}>{children}</ButtonElement>;
});

Button.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func
};

export default Button;


// WEBPACK FOOTER //
// ./src/components/ui-ant/Button/index.js